'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
type RampWrapperProps = {
  pubId?: string;
  websiteId?: string;
  isEnabled?: boolean;
};
const scriptId = 'ramp-config-script';

/**
 * Playwire's ramp script loader component
 * ref: https://support.playwire.com/implement-the-next.js-component-simple-implementation
 */
export default function RampWrapper({
  pubId,
  websiteId,
  isEnabled
}: RampWrapperProps) {
  const pathname = usePathname() ?? '/';
  const [rampComponentLoaded, setRampComponentLoaded] = useState(false);
  useEffect(() => {
    if (!isEnabled) {
      return;
    }
    if (!pubId || !websiteId) {
      console.warn('[RAMP] Missing Publisher Id or Website Id');
      return;
    }
    if (!rampComponentLoaded) {
      // Ensure ramp object exists
      window.ramp = window.ramp || {
        que: []
      };
      window.ramp.que = window.ramp.que || [];
      window.ramp.passiveMode = true;

      // Load the Ramp configuration script
      const configScript = document.createElement('script');
      configScript.id = scriptId;
      configScript.src = `https://cdn.intergient.com/${pubId}/${websiteId}/ramp.js`;
      configScript.dataset['cfasync'] = 'false';
      configScript.async = true;
      configScript.defer = true;
      document.body.appendChild(configScript);
      configScript.onload = () => {
        setRampComponentLoaded(true);
      };
    }
    return () => {};
  }, [isEnabled, pubId, rampComponentLoaded, websiteId]);
  useEffect(() => {
    if (rampComponentLoaded && isEnabled) {
      window.ramp?.que.push(() => {
        window.ramp?.spaNewPage?.(pathname);
      });
    }
  }, [isEnabled, pathname, rampComponentLoaded]);
  return null;
}